import * as ko from 'knockout'
import { getOrdinalSuffix } from '@mobi/utils/number/ordinal'
import { Disposable } from '../../../../AppUtils/Framework/Disposable/Disposable'
import Guard from '../../../../AppUtils/Framework/Guard'
import type { IObservableFinisher } from '../../../Model/Observables/IObservableFinisher'

export class FinisherPlaceViewModel extends Disposable {
  public finisher?: IObservableFinisher
  public ordinal?: ko.PureComputed<string>

  constructor(params: { finisher: IObservableFinisher }) {
    super()

    Guard.notNull(params.finisher)

    this.finisher = params.finisher
    this.ordinal = ko.pureComputed<string>(() => {
      const placing = (this.finisher as IObservableFinisher).placing()
      return getOrdinalSuffix(placing, true)
    })
  }
}
